import { isPlatformBrowser } from '@angular/common';
import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { Environment, ENVIRONMENT_NAME, USE_FAKES } from '@freelancer/config';
import { PendingTasks } from '@freelancer/pending-tasks';

// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
// Application-wide code should be avoided as much as possible; does your code
// needs:
// - to be loaded on ALL logged-in pages?
// - AND to be loaded on ALL logged-out pages?
// - AND to be loaded on the Admin?
// - ...
// Probably not.
@Component({
  standalone: false,
  selector: 'app-root',
  template: `
    <app-toast-alerts />
    <fl-pwa />
    <fl-seo />
    @defer (when useFakes) {
      <fl-fake-collections />
    }
    <router-outlet />
    @if (isBrowser) {
      <fl-tracking />
    }
    <fl-error-tracking></fl-error-tracking>
    <fl-location />
    <fl-modal />
    <fl-network-alert />
    <fl-notifications />
    <fl-update-native-alert />
    <fl-theme />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private platformId = inject(PLATFORM_ID);
  private environment = inject<Environment>(ENVIRONMENT_NAME);
  private pendingTasks = inject(PendingTasks);
  protected useFakes = inject(USE_FAKES);

  isBrowser: boolean;

  ngOnInit(): void {
    this.isBrowser = isPlatformBrowser(this.platformId);

    // FIXME: T267853 - detect Protractor env better
    if (this.isBrowser && this.environment !== 'prod') {
      this.pendingTasks.monitor();
    }
  }
}
